export default __webpack_public_path__ + "static/media/ic-time-marker.b2b35f12.svg";